import React, { useState } from "react";
import { Tabs, Table, Card, Tag, Button, Row, Col, Statistic } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import 'leaflet/dist/leaflet.css';
import HeroTradeMap from "./HeroTradeMap";

// Dummy Data
const importData = [
    { key: 1, product: "Hybrid Maize Seeds", origin: "Kenya", price: "€500/T", delivery: "14 days" },
    { key: 2, product: "NPK 15-15-15 Fertilizer", origin: "Morocco", price: "€420/T", delivery: "10 days" },
];

const exportData = [
    { key: 1, product: "Pineapple (Fresh)", destination: "France", price: "€800/T", demand: "High" },
    { key: 2, product: "Sesame Seeds", destination: "India", price: "€1,200/T", demand: "Medium" },
];

const techData = [
    { key: 1, product: "Solar-Powered Irrigation Pump", origin: "China", price: "€1,200", availability: "Available" },
    { key: 2, product: "Cassava Processing Unit", origin: "Ghana", price: "€5,000", availability: "Available" },
];

const HeroImportExportDashboard = () => {
    const [activeTab, setActiveTab] = useState("import");

    const columnsImport = [
        { title: "Product", dataIndex: "product", key: "product" },
        { title: "Origin", dataIndex: "origin", key: "origin" },
        { title: "Price", dataIndex: "price", key: "price" },
        { title: "Delivery", dataIndex: "delivery", key: "delivery" },
    ];

    const columnsExport = [
        { title: "Product", dataIndex: "product", key: "product" },
        { title: "Destination", dataIndex: "destination", key: "destination" },
        { title: "Price", dataIndex: "price", key: "price" },
        {
            title: "Demand",
            dataIndex: "demand",
            key: "demand",
            render: demand => <Tag color={demand === "High" ? "green" : "orange"}>{demand}</Tag>
        },
    ];

    const columnsTech = [
        { title: "Product", dataIndex: "product", key: "product" },
        { title: "Origin", dataIndex: "origin", key: "origin" },
        { title: "Price", dataIndex: "price", key: "price" },
        { title: "Availability", dataIndex: "availability", key: "availability" },
    ];

    // Chart.js Dummy Data
    const priceTrendData = {
        labels: ["Jan", "Feb", "Mar", "Apr", "May"],
        datasets: [
            {
                label: "Export Prices (€ per Tonne)",
                data: [800, 820, 790, 850, 870],
                borderColor: "#52c41a",
                backgroundColor: "rgba(82, 196, 26, 0.2)",
            },
        ],
    };

    return (
        <div className="p-4">
            {/* Summary Cards */}
            <Row gutter={16} className="mb-4">
                <Col span={6}>
                    <Card>
                        <Statistic title="Export Opportunities" value={15} valueStyle={{ color: "#3f8600" }} prefix={<ArrowUpOutlined />} />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic title="Import Offers" value={8} valueStyle={{ color: "#cf1322" }} prefix={<ArrowDownOutlined />} />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic title="Best Current Market" value="Pineapple → EU" />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic title="Active Contracts" value={5} />
                    </Card>
                </Col>
            </Row>

            {/* Tabs for Import, Export, Tech */}
            <Tabs activeKey={activeTab} onChange={setActiveTab} type="card">
                <Tabs.TabPane tab="Imports" key="import">
                    <Table dataSource={importData} columns={columnsImport} pagination={false} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="Exports" key="export">
                    <Table dataSource={exportData} columns={columnsExport} pagination={false} />
                    <HeroTradeMap /> {/* Map showing flows */}
                    {/*<div className="mt-4">*/}
                    {/*    <Line data={priceTrendData} />*/}
                    {/*</div>*/}
                </Tabs.TabPane>
                <Tabs.TabPane tab="Technology & Services" key="tech">
                    <Table dataSource={techData} columns={columnsTech} pagination={false} />
                </Tabs.TabPane>
            </Tabs>
        </div>
    );
};

export default HeroImportExportDashboard;
